import {
  axios_nomination,
} from '@/plugins/axios';

import configuration from '@/configurations';

class AggregatorUserDataRepository {

  /**
   * @returns {Promise}
   */
  async getContactsReferential() {
    const result = await axios_nomination.get(
      `${configuration.api_host}/v1/aggregator-user-data/contacts/referential`
    );

    return result.data;
  }

  /**
   * @returns {Promise}
   */
  async getCompaniesReferential() {
    const result = await axios_nomination.get(
      `${configuration.api_host}/v1/aggregator-user-data/companies/referential`
    );

    return result.data;
  }

  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async searchContactColumnValues(criteria) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/aggregator-user-data/contacts/column-values`,
      criteria
    );

    return result.data;
  }

  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async searchContacts(criteria) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/aggregator-user-data/contacts`,
      criteria
    );

    return result.data;
  }

  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async searchContactIds(criteria) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/aggregator-user-data/contacts/ids`,
      criteria
    );

    return result.data;
  }

  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async searchCompanyIds(criteria) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/aggregator-user-data/companies/ids`,
      criteria
    );

    return result.data;
  }

  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async searchAccounts(criteria) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/aggregator-user-data/companies`,
      criteria
    );

    return result.data;
  }

  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async searchCompanyColumnValues(criteria) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/aggregator-user-data/companies/column-values`,
      criteria
    );

    return result.data;
  }

  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async searchCompaniesSimple(criteria) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/aggregator-user-data/companies-simple`,
      criteria
    );

    return result.data;
  }

  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async searchInteractions(criteria) {
    const result = await axios_nomination.get(
      `${configuration.api_host}/v1/aggregator-user-data/enriched-interactions`,
      {
        params: criteria,
      }
    );

    return result.data;
  }

  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async searchTasks(criteria) {
    const result = await axios_nomination.get(
      `${configuration.api_host}/v1/aggregator-user-data/enriched-tasks`,
      {
        params: criteria,
      }
    );

    return result.data;
  }
}

const aggregator_user_data_repository = new AggregatorUserDataRepository();

export {
  aggregator_user_data_repository,
};
